"use client"

import { useQuery } from "@tanstack/react-query"
import { Skeleton } from "@/components/ui/skeleton"
import Image from "next/image"

interface EyecatchImageProps {
  id: string
  initialPic: string
}

const fetchEyecatch = async (id: string) => {
  const response = await fetch(`/api/notion/eyecatch/${id}`)
  const data = await response.json()
  if (data.eyecatch) {
    return data.eyecatch
  }
  throw new Error("Eyecatch not found")
}

const EyecatchImage = ({ id, initialPic }: EyecatchImageProps) => {
  const {
    data: pic,
    error,
    isLoading,
  } = useQuery(["eyecatch", id], () => fetchEyecatch(id), {
    initialData: initialPic,
  })

  return (
    <div className="">
      {isLoading || !pic || error ? (
        <Skeleton className="w-full h-[450px]" />
      ) : (
        <Image
          src={pic}
          alt="post_pic"
          width={1280}
          height={720}
          className="w-full h-auto"
          priority
        />
      )}
    </div>
  )
}

export default EyecatchImage
